import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { OverlayPositionX, SelectOption } from '../../../../ui/gzSelect/types';
import { SelectExtraOptionsEvents } from '../types';

export class GridSelectionExtraOptionsWebComponent extends LitElement {
  @property({ type: Array, attribute: true, reflect: true })
  selectionOptions: SelectOption[];

  static get styles() {
    return styles;
  }

  render() {
    return html` <div class="container">
      <gz-select
        .options="${this.selectionOptions}"
        overlayPositionX="${OverlayPositionX.LEFT}"
        closeOnMouseLeave
        @selectionChanged="${this.handleSelectionChange}"
      >
        <gz-icon-button
          icon="ds-icon-textbox_decrease"
          buttonColor="secondary"
          buttonType="square"
          buttonfill="quiet"
          fontSize="20"
          size="20"
          class="inline-menu-trigger"
        ></gz-icon-button>
      </gz-select>
    </div>`;
  }

  private handleSelectionChange(event) {
    const selectedOption = event.detail.selected;
    const newEvent = new CustomEvent(SelectExtraOptionsEvents.EXTRA_OPTION_SELECTION_CHANGE, {
      detail: {
        selected: selectedOption,
      },
      bubbles: true,
      composed: true,
    });

    this.dispatchEvent(newEvent);

    event.stopPropagation();
  }
}
